import {connect} from 'react-redux';
import React from 'react';
import moment from 'moment';

import SelectEventScreen from './common/SelectEventScreen';
import Validate from '../../../validate/Validate';

const ConnectedScreenComponent = connect((state, props) => {
    let now = moment();
    return {
        i18n: state.i18n.translations,
        events: state.events.loadedEvents
            .map(id => state.events[id].event)
            .filter(event => moment(event.end_utc) < now)
            .filter(event => event._isEvent),
    };
})(SelectEventScreen);

export default props => (
    <Validate
        validate={state => {
            if (!state.events.loadedEvents.map(id => state.events[id].event).filter(event => event._isEvent).length) {
                throw new Error('No events to delete');
            }
        }}>
        <ConnectedScreenComponent {...props.match.params} />
    </Validate>
);
